<template>
    <div>
        <view-item v-if="!!item" :item="item" @success="resetItems" @cancel="item = false"
            @delete-item="deleteType"></view-item>

        <list-items v-else title="Transaction Types" :items="items" @show-item="showItem" ref="table">
            <b-button id="add-transaction-type-btn" variant="primary" v-if="hasPermissionCreate" block @click="item = {}"><img v-b-tooltip.hover
                    :title="$addLabel()" src="@/assets/images/icon/blue-add.svg"></b-button>
        </list-items>
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import utilityMixins from '@/mixins/utilityMixins'
import ListItems from './ListItems'
import ViewItem from './ViewItem'

export default {
    name: 'transactionTypes',
    components: {
        ListItems,
        ViewItem,
    },
    mixins: [popupMixins, permissionsMixins, utilityMixins],
    data() {
        return {
            item: null,
        }
    },
    mounted() {
        this.doSearch()
    },
    computed: {
        componentName() { return this.$translate('transaction_type') },
        items() {
            const items = this.$store.state.transactionType.items
            return items
        },
    },

    methods: {
        async doSearch() {
            await this.$store.dispatch('transactionType/fetchAll')
        },

        showItem(id) {
            this.item = this.items.find(x => x.id === id)
        },

        resetItems(status) {

            this.genericToast(this.componentName, status, 'success', `${this.componentName} ${status.toLowerCase()} ${this.$translate("succcessfully")}`)
            // this.doToast('Success', `Item ${status}!`, 'success')
            this.item = null
            this.doSearch()
        },
    },
}
</script>
<style></style>
